import { Route, Routes as RouterRoutes } from 'react-router';

import { TourContainer } from './tour_container';
import { TourListContainer } from './tour_list_container';
import { Routes } from '../../routes';

export const ToursContainer = () => (
  <RouterRoutes>
    <Route path={Routes.Tour.relativePath} element={<TourContainer />} />
    <Route index element={<TourListContainer />} />
  </RouterRoutes>
);
